import { useWeight } from '../../../context/WeightContext';
import { Card } from '../../ui/Card';

export function WeightHistory() {
  const { entries, formatWeight: formatWeightHelper, getDeltaDisplay: getDeltaDisplayHelper } = useWeight();

  if (entries.length === 0) {
    return (
      <div className="space-y-4 p-4 ">
        <div className="flex items-center justify-between px-2 py-3">
          <h2 className="text-xl font-bold text-on-surface">Weight History</h2>
          <span className="rounded-full bg-primary/20 px-3 py-1 text-xs font-medium text-primary">All time</span>
        </div>
        <div className="px-2">
          <Card className="flex flex-col items-center justify-center py-12 bg-gradient-to-br from-surface-container-high to-surface border border-outline">
            <p className="text-on-surface-variant">No weight entries yet. Start tracking your progress!</p>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4 p-4 ">
      <div className="flex items-center justify-between px-2 py-3">
        <h2 className="text-xl font-bold text-on-surface">Weight History</h2>
        <span className="rounded-full bg-primary/20 px-3 py-1 text-xs font-medium text-primary">All time</span>
      </div>

      <div className="space-y-3 px-2">
        {entries.map((entry, index) => {
          const prevWeight = entries[index + 1]?.weight_kg;
          const diff = prevWeight ? entry.weight_kg - prevWeight : 0;
          const delta = getDeltaDisplayHelper(diff);

          return (
            <Card key={entry.id} className="bg-surface-container border border-outline px-4 py-3 flex items-center justify-between">
              <div>
                <span className="block text-sm font-medium text-on-surface">{formatWeightHelper(entry.weight_kg)}</span>
                <span className="block text-xs text-on-surface-variant">
                  {new Date(entry.recorded_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: '2-digit' })}
                </span>
              </div>
              <span className={`text-xs font-medium ${delta.class}`}>
                {delta.text}
              </span>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
